<template>
  <div class="flex flex-col">
    <h3>Карти та послуги</h3>

    <card-creator />

    <div class="flex items-center mx-auto gap-12">
      <div class="flex gap-2">
        <button
          class="p-2 w-[120px] hover:bg-indigo-300 hover:text-white transition duration-300 rounded-xl"
          :class="productType === 1 && 'bg-indigo-400 text-white'"
          @click="productType = 1"
        >
          Абонементи
        </button>
        <button
          class="p-2 w-[120px] hover:bg-indigo-300 hover:text-white transition duration-300 rounded-xl"
          :class="productType === 2 && 'bg-indigo-400 text-white'"
          @click="productType = 2"
        >
          Разові
        </button>
      </div>
      <div class="mx-auto flex items-center gap-2 py-2">
        <input
          class="p-2"
          type="text"
          placeholder="Пошук"
          v-model="search_query"
        />
        <img
          src="@/assets/icons/cancel.png"
          @click="search_query = ''"
          class="h-4 w-4 cursor-pointer"
        />
      </div>
      <div>
        <select
          v-model="currentTrainingType"
          class="py-2 px-1 rounded-lg w-[300px]"
          @change="onTrainingTypeChange"
        >
          <option value="">Всі типи тренувань</option>
          <option v-for="trainingType in getTrainingTypes" :value="trainingType" :key="trainingType.name">
            {{ getVerboseTrainingType(trainingType) }}
          </option>
        </select>
      </div>
    </div>


    <PlansTable
      :products="products"
      :totalRecords="totalRecords"
      :currentPage="currentPage"
      v-if="productType === 1"
      @page-change="onPageChange"
      @choose-product="showEditModal"
      @product-deleted="onProductDeleted"
      @show-alert="showAlert"
    />

    <SoloTable
      :products="products"
      :totalRecords="totalRecords"
      :currentPage="currentPage"
      v-if="productType === 2"
      @page-change="onPageChange"
      @choose-product="showEditModal"
      @product-deleted="onProductDeleted"
      @show-alert="showAlert"
    />

    <Alert
      :class="color"
      v-bind:text="AlertText"
      v-bind:activErr="errorVisible"
    ></Alert>

    <ProductDetails
      v-if="chosenEditedProductId"
      :productId="chosenEditedProductId"
      :isCard="isCard"
      :isVisible="isModalVisible"
      @close="closeModal"
      @product-updated="onProductUpdated"
      :currentProductType="productType"
    />
  </div>
</template>

<script>
import CardCreator from "@/components/modals/CardCreator";
import PlansTable from "../../components/Products/PlansTable.vue";
import SoloTable from "../../components/Products/SoloTable.vue";
import Alert from "@/components/Toasts/Alert";
import ProductDetails from "../../components/Products/ProductDetails.vue";
import { TRAINING_TYPES } from "../../components/Products/Constants";
export default {
  name: "ProductsMain",
  components: {
    CardCreator,
    PlansTable,
    Alert,
    SoloTable,
    ProductDetails,
  },
  data: function () {
    return {
      products: [],
      productType: 1,
      totalRecords: 0,
      currentPage: 1,
      chosenEditedProductId: null,
      isCard: 1,
      color: "",
      AlertText: "",
      errorVisible: false,
      search_query: "",
      isModalVisible: false,
      currentTrainingType: "",
    };
  },
  methods: {
    getVerboseTrainingType(type) {
      return TRAINING_TYPES[type];
    },
    async getProducts(params) {
      try {
        let res = await this.$api.products.getProducts(params);
        this.products = res.data.products;
        this.totalRecords = res.data.total_records;
      } catch (error) {
        this.showAlert("Помилка завантаження товарів", "bg-red-200");
      }
    },
    async onTrainingTypeChange() {
      if (this.currentTrainingType === "") {
        this.currentPage = 1;
        await this.getProducts({
          page: 1,
          productType: this.productType,
        });
        return;
      }
      this.currentPage = 1;
      await this.getProducts({
        page: 1,
        productType: this.productType,
        training_type: this.currentTrainingType,
      });
    },
    async onPageChange(newPage) {
      this.currentPage = newPage;
      await this.getProducts({
        page: newPage,
        productType: this.productType,
        search_query: this.search_query,
        training_type: this.currentTrainingType
      });
    },
    showAlert(text, color) {
      this.errorVisible = true;
      this.AlertText = text;
      this.color = color;
      setTimeout(() => {
        this.errorVisible = false;
      }, 4000);
    },
    async onProductUpdated() {
      this.showAlert("Товар успішно оновлено", "bg-green-600");
      await this.getProducts({
        page: this.currentPage,
        productType: this.productType,
        training_type: this.currentTrainingType
      });
    },
    async onProductDeleted() {
      this.showAlert("Товар успішно видалено", "bg-green-600");
      await this.getProducts({
        page: this.currentPage,
      });
    },
    showEditModal(product, isCard) {
      this.chosenEditedProductId = product.id; // Set the selected product ID
      this.isCard = isCard === 1; // Determine if it's a card product
      this.isModalVisible = true; // Show the modal
      console.log(this.chosenEditedProductId);
      console.log(this.isModalVisible)
    },
    closeModal() {
      console.log('closeModal')
      this.isModalVisible = false; // Hide the modal
      this.chosenEditedProductId = null; // Reset the selected product
    },
  },
  watch: {
    search_query: function (newVal) {
      if (!newVal.length)
        this.getProducts({
          page: 1,
        });
      if (newVal.length < 3) return;
      this.getProducts({
        page: 1,
        productType: this.productType,
        search_query: newVal,
      });
    },
    productType: function (newVal, oldVal) {
      if (newVal === oldVal) return;
      this.currentPage = 1;
      this.getProducts({
        page: 1,
        productType: newVal,
      });
    },
  },
  async mounted() {
    await this.getProducts({
      page: this.currentPage,
      productType: this.productType,
    });
  },
  computed: {
    getTrainingTypes() {
      return Object.keys(TRAINING_TYPES);
    },
  }
};
</script>

<style scoped></style>
